// Card.js
//working of individual cards like the ability to toggle or flip and there design
//is carried out in this file
function Card({ item, handleSelectedCards, toggled, stopflip, cardType }) {
    return (
        <div className="item">
            <div className={toggled ? "toggled" : ""}>
                {item.type === "picture" ?
                        <img className="face cover-size itemPicture itemSize" src={item.itemImg} alt="item" />
                    :
                        <div className="face cover-size itemText itemSize"> {item.itemName} </div>
                }
                <div
                    className={cardType}
                    onClick={() => !stopflip && handleSelectedCards(item)}
                >
                    
                    {" "}
                </div>
            </div>
        </div>
    );
}

export default Card;
